import { IGameParams } from './interfaces/i_game_params';
import { IconDescr } from './long_icon_enumerator';

export class SlotParams implements IGameParams {
  private readonly _gameId: string;
  public readonly reelsCount: number;
  public readonly linesCount: number;
  public readonly longIcons: IconDescr[];

  constructor(gameId: string, reelsCount: number, linesCount: number, longIcons: IconDescr[]) {
    this._gameId = gameId;
    this.reelsCount = reelsCount;
    this.linesCount = linesCount;
    this.longIcons = longIcons || [];
  }

  public get gameId(): string {
    return this._gameId;
  }

  public get iconsCount(): number {
    return this.reelsCount * this.linesCount;
  }

  public get groupsCount(): number {
    return this.reelsCount;
  }

  public get maxIconsPerGroup(): number {
    return this.linesCount;
  }
}
